import { Placeholder } from '@/tools/models/class-builder.models';
import { PlaceholderService } from '@/tools/services/placeholder.service';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  components: {
    EdClassBuilderPlaceholder: () => import(/* EdClassBuilderPlaceholder */'@/tools/components/class-builder/ed-class-builder-placeholder/ed-class-builder-placeholder.component.vue'),
  }
})
export default class ClassBuilderPlaceholderView extends Vue {
  classDetail: any = null;
  placeholderSchedule: any = null;
  placeholders: Placeholder[] = null;

  created() {
    this.classDetail = this.$route.meta.classDetail;
    this.placeholderSchedule = this.$route.meta.schedulePlaceholder;
    this.placeholders = this.$route.meta.placeholders;
    this.$edEventBus.$on('refetchAssingMainPlaceholder', async () => {
      this.placeholderSchedule = await PlaceholderService.getSchedulePlaceholder(
        Number(this.$route.params.classId),
        Number(this.$route.params.placeholderId)
      );
    });
  }

  returnToClassBuilder() {
    this.$router.push({ name: 'builder' });
  }
}